(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8444],{

/***/ 42540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Company/memos/2021-12-19-small-seller-pricing-and-removing-weekly-billing/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "Ryan Hill",
      dateTime: "2021-12-19",
      tag: "Memo",
      title: "$8/mo for small sellers & Removing weekly billing",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: "Update:"
        }), " The Small Seller program is no longer available. Learn more", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/company/memos/2022-03-02-ending-small-seller-program",
          children: "here."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Hi everyone, I\u2019m Ryan and I oversee our Premium offering here at OneShop. I\u2019m following up on", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/company/memos/2021-12-13-affordability-changes",
          children: "this week\u2019s earlier update"
        }), ' ', "about the Affordability Program. I\u2019m also sharing that we will be removing weekly pricing as an option for new subscriptions. Please read the full details below."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "New price for small sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Small sellers will pay $8/mo every month they sell less than $80/mo in goods."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You\u2019re considered a small seller if you\u2019ve sold less than $1,500 in the past year and $3,000 all-time."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As always, we reserve the right to deny special pricing for sellers that we suspect are abusing the spirit of the program."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [' ', "Since part of our team will be gone during the week of Christmas, this will be available on December 27th. Thanks for being so patient with revisions to the program.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Removing weekly billing"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We will remove the weekly billing by the end of December. We originally added it to lower the upfront commitment for people new to reselling."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you are paying weekly today, you can keep your plan for the next 6 months. On June 19, 2022 if you are still subscribed you will be automatically upgraded to the $45/mo plan. If you switched today you\u2019d save $16 over the next 6 months."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you cancel we may not honor renewing your access to the weekly plan."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/company/memos/2021-12-19-small-seller-pricing-and-removing-weekly-billing.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Memo: $8/mo for small sellers & removing weekly billing"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Memo: $8/mo for small sellers & removing weekly billing"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-12-19T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-12-19T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Memo"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 77800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/memos/2021-12-19-small-seller-pricing-and-removing-weekly-billing",
      function () {
        return __webpack_require__(42540);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(77800); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);